var map = {
	"./duel_accepted.svg": 919,
	"./new_referral.svg": 920,
	"./rating_group_update.svg": 921,
	"./subscription_prolong.svg": 922,
	"./team_invite.svg": 923,
	"./tournament_created.svg": 924,
	"./tournament_won.svg": 925
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 435;